import {
  CategoryGetResDTO,
  CategoryPostReqDTO,
  CategoryPutReqDTO,
} from "../api/category-dto.js";

/**
 * Category 모델 정의
 * 프론트엔드에서 사용할 Category 타입
 */
export interface Category {
  id: string;
  nameKo: string;
  nameEn?: string;
  numOfArticles: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO를 Category 모델로 변환하는 함수
 */
export const toCategory = (dto: CategoryGetResDTO): Category => {
  return {
    id: dto.id,
    nameKo: dto.nameKo,
    nameEn: dto.nameEn,
    numOfArticles: dto.numOfArticles,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};

/**
 * Category 모델을 POST 요청 DTO로 변환하는 함수
 */
export const toCategoryPostReqDTO = (
  category: Omit<Category, "id" | "createdAt" | "updatedAt">,
): CategoryPostReqDTO => {
  return {
    nameKo: category.nameKo,
    nameEn: category.nameEn,
    numOfArticles: category.numOfArticles,
  };
};

/**
 * Category 모델을 PUT 요청 DTO로 변환하는 함수
 */
export const toCategoryPutReqDTO = (
  category: Partial<Category> & { id: string },
): CategoryPutReqDTO => {
  return {
    id: category.id,
    nameKo: category.nameKo,
    nameEn: category.nameEn,
    numOfArticles: category.numOfArticles,
    updatedAt: category.updatedAt || new Date().toISOString(),
  };
};
